import { rootDoc } from "../../helpers/dom-selectors.js";
export default function makeHeader({ header, logo }) {
    const COLLAPSED_HEADER_HEIGHT = 50;
    const EXPANDED_HEADER_HEIGHT = 90;
    let initialized = false;
    return Object.freeze({
        init
    });
    function init() {
        if (initialized)
            return;
        initialized = true;
        _addScrollListener();
    }
    function _addScrollListener() {
        window.addEventListener('scroll', (e) => {
            const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
            _handleHeaderOnScroll(scrollTop);
        });
    }
    function _handleHeaderOnScroll(scrollTop) {
        if (scrollTop > 0)
            _collapseHeader();
        else
            _expandHeader();
    }
    function _collapseHeader() {
        rootDoc.style.setProperty("--headerHeight", COLLAPSED_HEADER_HEIGHT + "px");
        header.classList.add('header-collapsed');
        logo.classList.add('logo-collapsed');
    }
    function _expandHeader() {
        rootDoc.style.setProperty("--headerHeight", EXPANDED_HEADER_HEIGHT + "px");
        header.classList.remove('header-collapsed');
        logo.classList.remove('logo-collapsed');
    }
}
